'use client'

import { Heart } from 'lucide-react'
import { track } from '@/lib/analytics'
import { DONATE_URL } from '@/lib/constants'

/**
 * "Fuel this app" — the donation link in the header.
 *
 * A plain link to the Stripe Payment Link (`DONATE_URL`), opened in a new tab
 * so an in-progress estimate survives. Brand-purple pill with a light glint
 * sweeping across every few seconds; the glint is `motion-safe` only, so it
 * never runs for users who prefer reduced motion. Below `sm` it collapses to
 * the heart icon — the header row also holds Share / Export / Reset on phones.
 */
export function DonateButton() {
	return (
		<a
			href={DONATE_URL}
			target="_blank"
			rel="noopener"
			onClick={() => track('DonateClicked')}
			aria-label="Fuel this app — donate via Stripe (opens in a new tab)"
			title="Free, no ads — chip in if it saved you money"
			className="group relative inline-flex h-8 shrink-0 items-center gap-1.5 overflow-hidden rounded-full bg-brand px-2.5 text-sm font-medium text-white shadow-[0_0_14px_-2px_var(--color-brand)] outline-none transition-[transform,box-shadow] duration-200 hover:-translate-y-px hover:shadow-[0_0_20px_0_var(--color-brand)] focus-visible:ring-[3px] focus-visible:ring-ring/50 sm:px-3"
		>
			<span
				aria-hidden
				className="pointer-events-none absolute inset-y-0 left-0 w-1/3 -translate-x-[120%] bg-gradient-to-r from-transparent via-white/40 to-transparent motion-safe:animate-donate-glint"
			/>
			<Heart
				className="relative size-3.5 fill-white/90 transition-transform duration-200 group-hover:scale-110"
				aria-hidden
			/>
			<span className="relative hidden sm:inline">Fuel this app</span>
		</a>
	)
}
